import { useRef, useState } from 'react';
import { ConfirmationDialog } from '../../../core/components/dialogs/confirmationDialog';
import ReCAPTCHA from 'react-google-recaptcha';
import { ReCaptchaState, validateReCaptcha } from '../../reCaptchaValidator';
import { SessionTimeoutPresenter } from '../presenter';

export interface SessionTimeoutConfirmationDialogProps {
  isOpen: boolean;
  onContinueScheduling: () => void;
  onCancel: () => void;
}

const SessionTimeoutConfirmationDialog: React.FC<
  SessionTimeoutConfirmationDialogProps
> = (props: SessionTimeoutConfirmationDialogProps) => {
  const reCaptchaRef = useRef<ReCAPTCHA>(null);
  const [reCaptchaState, setReCaptchaState] = useState<ReCaptchaState>(
    ReCaptchaState.OK
  );

  const onReCaptchaChange = () => {
    setReCaptchaState(ReCaptchaState.OK);
  };

  const onContinueScheduling = async () => {
    const validateReCaptchaCall = async (): Promise<boolean> => {
      const newReCaptchaState = await validateReCaptcha(reCaptchaRef);
      setReCaptchaState(newReCaptchaState);

      return newReCaptchaState === ReCaptchaState.OK;
    };

    if (await validateReCaptchaCall()) {
      props.onContinueScheduling();
    }
  };

  return (
    <ConfirmationDialog
      title="Still with us?"
      isOpen={props.isOpen}
      confirmCaption="Continue Scheduling Online"
      onConfirm={onContinueScheduling}
      cancelCaption="Cancel, and go back home"
      onCancel={props.onCancel}
      maxWidth={345}
    >
      <SessionTimeoutPresenter
        reCaptchaRef={reCaptchaRef}
        reCaptchaState={reCaptchaState}
        onReCaptchaChange={onReCaptchaChange}
      />
    </ConfirmationDialog>
  );
};

export default SessionTimeoutConfirmationDialog;
